import { fetch } from './api.js'

export async function getBlocks(includeDrafts = false) {
  const query = includeDrafts ? '?all=true' : ''
  const data = await fetch(`/parse/classes/Block${query}`)
  return data.results || []
}

export async function getBlockById(id) {
  const data = await fetch(`/parse/classes/Block/${id}`)
  return data
}

export async function createBlock(blockData) {
  return await fetch('/parse/classes/Block', {
    method: 'POST',
    body: JSON.stringify(blockData),
  })
}

export async function updateBlock(id, blockData) {
  return await fetch(`/parse/classes/Block/${id}`, {
    method: 'PUT',
    body: JSON.stringify(blockData),
  })
}

export async function deleteBlock(id) {
  return await fetch(`/parse/classes/Block/${id}`, {
    method: 'DELETE',
  })
}
